import React from "react";
import { Form, Row, Col, Button } from "react-bootstrap";
import { FaSyncAlt, FaFilter } from "react-icons/fa";
import { MOIS_LIST, ANNEES_LIST, JOURS_RECENTS_LIST } from "./useStatsDashboard";

const StatsFiltersBar = ({
  annee,
  setAnnee,
  mois,
  setMois,
  joursRecents,
  setJoursRecents,
  onRefresh,
  loading,
}) => (
  <div className="stats-filters-bar">
    <div className="stats-filters-title">
      <FaFilter /> Filtres
    </div>
    <Row className="g-3 align-items-end">
      <Col xs={6} md={3}>
        <Form.Label>Année</Form.Label>
        <Form.Select value={annee} onChange={(e) => setAnnee(e.target.value)} disabled={loading}>
          {ANNEES_LIST.map((a) => (
            <option key={a.value} value={a.value}>{a.label}</option>
          ))}
        </Form.Select>
      </Col>
      <Col xs={6} md={3}>
        <Form.Label>Mois</Form.Label>
        <Form.Select value={mois} onChange={(e) => setMois(e.target.value)} disabled={loading}>
          {MOIS_LIST.map((m) => (
            <option key={m.value} value={m.value}>{m.label}</option>
          ))}
        </Form.Select>
      </Col>
      <Col xs={6} md={3}>
        <Form.Label>Nouveautés (lignes ajoutées)</Form.Label>
        <Form.Select
          value={joursRecents}
          onChange={(e) => setJoursRecents(Number(e.target.value))}
          disabled={loading}
        >
          {JOURS_RECENTS_LIST.map((j) => (
            <option key={j.value} value={j.value}>{j.label}</option>
          ))}
        </Form.Select>
      </Col>
      <Col xs={6} md={3} className="d-flex justify-content-md-end">
        <Button
          variant="outline-secondary"
          className="stats-refresh-btn"
          onClick={onRefresh}
          disabled={loading}
        >
          <FaSyncAlt className={loading ? "spin" : ""} /> Actualiser
        </Button>
      </Col>
    </Row>
  </div>
);

export default StatsFiltersBar;
